import React from "react";
import {useSelector} from "react-redux";
import {buLogoImgaeMapping} from "../../util";
import "./BuSpecificHeader.scss";

const BuSpecificHeader = () => {
  const {customerDetails} = useSelector((state) => {
    return {
      customerDetails: state.customerReducer?.customerDetails || null,
    };
  });
  return (
    <React.Fragment>
      <div
        className={`top-header-container top-header-bu-${customerDetails?.bu}`}
      >
        <img
          className="bu-icon"
          src={buLogoImgaeMapping[customerDetails?.bu] || null}
          alt="icon"
        />
        {customerDetails?.bu === "Tottus" && (
          <label className="top-header-text">
            {customerDetails?.bu.toUpperCase()}
          </label>
        )}
      </div>
    </React.Fragment>
  );
};

export default BuSpecificHeader;
